// LLM generated - Model Claude Opus 4
import { useIsFeatureEnabled } from '~/hooks/useIsFeatureEnabled';
import { FEATURE } from '~/common/enums/feature.enum';

import { useTreatment } from './useTreatment';

type ChatWebConfig = { chat?: string; posts?: string };

export function useChatWebFeatureFlags() {
  const isChatEnabledSimple = useIsFeatureEnabled(FEATURE.ENABLE_CHAT_WEB);
  const { treatment: chatWebTreatment } = useTreatment(FEATURE.ENABLE_CHAT_WEB);
  const { treatment, config } = chatWebTreatment ?? {};
  const chatConfig = config as ChatWebConfig | undefined;

  const isChatGloballyEnabled = isChatEnabledSimple || treatment === 'on';
  const isChatWebEnabled = isChatEnabledSimple || chatConfig?.chat === 'on';
  const isPostsWebEnabled = isChatEnabledSimple || chatConfig?.posts === 'on';

  return {
    isChatGloballyEnabled,
    isChatWebEnabled,
    isPostsWebEnabled,
  };
}
